namespace $.$$ {

	$mol_style_define( $shm_projects_page, {

		height: '100%',
		minHeight: 0,

		Menu_page: {
			flex: {
				basis: '14rem',
				grow: 0,
				shrink: 0,
			},
			Head: {
				height: '4rem',
				minHeight: '4rem',
				alignItems: 'center',
				flexWrap: 'nowrap',
			},
			Title: {
				minWidth: 0,
				minHeight: 0,
				alignItems: 'center',
				flexWrap: 'nowrap',
				gap: 0,
				padding: 0,
				overflow: 'hidden',
			},
		},

		Menu: {
			flex: {
				direction: 'column',
			},
		},

		Menu_title: {
			minWidth: 0,
			width: 0,
			padding: '0.5rem',
			flex: {
				grow: 1,
				shrink: 1,
				basis: 0,
			},
		},

		Project_actions: {
			padding: 0,
			width: '2.5rem',
			flex: {
				grow: 0,
				shrink: 0,
				basis: '2.5rem',
			},
		},

		Version_label: {
			padding: 0,
			color: $mol_theme.shade,
		},

		Product_page: {
			flex: { basis: '42rem', grow: 0, shrink: 1 },
			width: '42rem',
			maxWidth: '100%',
		},

		Draft_page: {
			flex: { basis: '42rem', grow: 0, shrink: 1 },
			width: '42rem',
			maxWidth: '100%',
		},

		Draft: {
			flex: { grow: 1, shrink: 1, basis: 0 },
			minHeight: '18rem',
		},

		Product_form: {
			minWidth: 0,
			padding: $mol_gap.block,
			Body: {
				gap: $mol_gap.block,
			},
		},

		Development_modes: {
			alignItems: 'center',
			gap: 0,
			minHeight: '2rem',
		},

		Preview_modes: {
			alignItems: 'center',
			gap: 0,
			minHeight: '2rem',
		},

		Preview_page: {
			minWidth: 0,
			Title: {
				minHeight: 0,
				padding: 0,
			},
		},

		Development_page: {
			flex: { basis: '30rem', grow: 0, shrink: 0 },
			width: '30rem',
			maxWidth: '30rem',
			Title: {
				minHeight: 0,
				padding: 0,
			},
		},

		Docs: {
			minWidth: 0,
			flex: { grow: 1, shrink: 1 },
		},

		Development_stage: {
			flex: { direction: 'column' },
			gap: $mol_gap.block,
		},

		Preview: {
			flex: {
				grow: 1,
				shrink: 1,
				basis: 0,
			},
			[ 'boxSizing' as any ]: 'border-box',
			border: {
				width: '1px',
				style: 'dashed',
				color: $mol_theme.line,
			},
			width: '100%',
			height: $mol_style_unit.vh( 90 ),
			minHeight: $mol_style_unit.vh( 90 ),
			maxHeight: 'none',
		},

		Tests_page: {
			minWidth: 0,
			flex: { grow: 1, shrink: 1 },
		},

		Project_tests: {
			minHeight: 0,
		},

		Prerelease_form: {
			flex: {
				direction: 'column',
			},
			gap: $mol_gap.block,
			padding: $mol_gap.block,
			background: { color: $mol_theme.card },
			border: { radius: $mol_gap.round },
		},

		Prerelease_summary: {
			flex: { direction: 'column' },
			gap: $mol_gap.block,
			padding: $mol_gap.block,
			background: { color: $mol_theme.card },
			border: { radius: $mol_gap.round },
		},

		Prerelease_transition: {
			font: {
				size: '1.25rem',
				weight: 'bold',
			},
			padding: 0,
		},

		Prerelease_deployment: {
			color: $mol_theme.shade,
		},

		Versions: {
			flex: {
				direction: 'column',
			},
		},

		Version_link: {
			padding: $mol_gap.block,
		},

		Version_details: {
			flex: {
				direction: 'column',
			},
			padding: $mol_gap.block,
			gap: $mol_gap.block,
			minWidth: 0,
		},

		Version_modes: {
			gap: 0,
		},

		Version_session: {
			flex: { direction: 'column' },
			padding: $mol_gap.block,
			gap: $mol_gap.block,
			minWidth: 0,
		},

		History_page: {
			flex: { basis: '19rem', grow: 0, shrink: 0 },
			Head: {
				height: '4rem',
				minHeight: '4rem',
				alignItems: 'center',
				flexWrap: 'nowrap',
			},
			Title: {
				minHeight: 0,
				alignItems: 'center',
				flexWrap: 'nowrap',
				padding: 0,
			},
		},

		Version_page: {
			flex: { basis: '42rem', grow: 1, shrink: 1 },
			minWidth: 0,
		},

		Version_date: {
			color: $mol_theme.shade,
		},

		Requirements_section: { flex: { direction: 'column' } },
		Changes_section: {
			flex: { direction: 'column' },
			padding: { top: $mol_gap.block },
			border: { top: { width: '1px', style: 'solid', color: $mol_theme.line } },
		},
		Tests_section: { flex: { direction: 'column' } },
		Other_artifacts_section: { flex: { direction: 'column' } },

		Requirements_title: { font: { size: '1.1rem', weight: 'bold' } },
		Changes_title: { font: { size: '1.1rem', weight: 'bold' } },
		Tests_title: { font: { size: '1.1rem', weight: 'bold' } },
		Other_artifacts_title: { font: { size: '1.1rem', weight: 'bold' } },

		Change: {
			flex: { direction: 'column' },
			gap: $mol_gap.text,
			padding: $mol_gap.text,
		},

		Change_screenshots: {
			display: 'grid',
			gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
			gap: $mol_gap.block,
		},

		Change_screenshot: {
			flex: { direction: 'column' },
			padding: 0,
			border: { width: '1px', style: 'solid', color: $mol_theme.line },
		},

		Change_screenshot_image: {
			width: '100%',
			height: '150px',
			objectFit: 'cover',
		},

		Version_test: {
			gap: $mol_gap.text,
			padding: $mol_gap.text,
			justifyContent: 'flex-start',
			border: { top: { width: '1px', style: 'solid', color: $mol_theme.line } },
		},

		Version_test_status: { color: $mol_theme.current },

		Other_artifact: {
			justifyContent: 'flex-start',
			padding: $mol_gap.text,
		},

	} )

}
